import { Link } from 'react-router-dom';
import { categories } from '@/mocks/asmrData';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dreamy%20abstract%20scene%20with%20soft%20flowing%20waves%20in%20warm%20amber%20and%20cream%20tones%2C%20ethereal%20sound%20visualization%20patterns%20like%20gentle%20ripples%2C%20floating%20luminous%20particles%20reminiscent%20of%20music%20notes%2C%20minimalist%20aesthetic%20with%20smooth%20gradients%2C%20calming%20and%20serene%20atmosphere%2C%20fine%20art%20photography%20style%20with%20shallow%20depth%20of%20field%2C%20warm%20golden%20hour%20lighting%2C%20no%20text%2C%20no%20people&width=1800&height=900&seq=hero-asmr-bg-01&orientation=landscape"
        alt="asmr1 沉浸式ASMR体验"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <span className="inline-block px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium tracking-wider mb-5 border border-background-50/20">
          沉浸式ASMR体验入口
        </span>
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-5">
          探索声音的
          <br className="hidden sm:block" />
          治愈力量
        </h1>
        <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
          asmr1 为您精选最优质的ASMR触发音合集、助眠音频与减压冥想内容，让每一次收听都带来深度颅内高潮感受与全身心的放松体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/trigger-sounds"
            className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap w-full sm:w-auto"
          >
            开始探索
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-base font-medium hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap w-full sm:w-auto"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-3 gap-4 md:gap-8 max-w-lg mx-auto">
          {[
            { num: '1000+', label: '精选音频' },
            { num: '6', label: '内容分类' },
            { num: '50万+', label: '忠实听众' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">{stat.num}</p>
              <p className="text-xs md:text-sm text-background-300 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}